import * as React from "react";
import { List, SimpleList, Datagrid, TextField, DateField, ShowButton } from 'react-admin';
import { useMediaQuery } from '@material-ui/core';

export const AuthorList = (props) => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    return (
        <List {...props}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.city}
                    tertiaryText={record => new Date(record.created_at).toLocaleDateString()}
                    linkType="show"
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="name" />
                    <DateField source="created_at" />
                    <DateField source="updated_at" />
                    <ShowButton />
                </Datagrid>
            )}
        </List>
    )
};
